<template>
  <div class="h-100 w-100 bg-facpya">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-10 col-md-6">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <div class="row justify-content-center">
                <div class="d-flex justiy-content-center">
                  <img
                    src="static/img/LogoUANL.png"
                    alt=""
                    class="img-fluid pt-4"
                    style="height: 200px;"
                  />
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-8 col-12">
                  <div class="p-5">
                    <div class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">
                        Bienvenido
                      </h1>
                    </div>
                    <form class="user" v-on:submit.prevent="Login">
                      <div class="form-group">
                        <input
                          required
                          :disabled="loading"
                          type="email"
                          v-model="email"
                          class="text-center form-control form-control-user"
                          id="email"
                          placeholder="Correo"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          required
                          :disabled="loading"
                          v-model="password"
                          type="password"
                          class="form-control text-center form-control-user"
                          id="password"
                          placeholder="Contraseña"
                        />
                      </div>
                      <button
                        :disabled="loading"
                        type="submit"
                        class="btn btn-user btn-facpya  btn-block"
                      >
                        <i v-if="loading" class="fas mr-2 fa-spinner fa-spin" />
                        Iniciar Sesión
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase.js";
import swal from "sweetalert";

const posterAuthorsEmails = [
  "ashley.bonilla@correounivalle.edu.co",
  "edwin.hoil@cinvestav.mx",
  "xiaoguang.chen@kuleuven.be",
  "santanacjl_12@hotmail.com",
  "pedro.perez@cinvestav.edu.mx",
  "jose.gonzalezavn@uanl.edu.mx",
  "abelardo.valdezgr@uanl.edu.mx",
  "felipe.rosasdz@uanl.edu.mx",
  "jesus.lopez.s@cinvestav.edu.mx",
  "dione_luiza@hotmail.com",
  "mariajimena.dehita@ietcc.csic.es",
  "llopezy@uanl.edu.mx",
  "elodie.piolet@insa-rennes.fr",
  "luiza.miranda@ugent.be",
  "rvisairom@gmail.com",
  "al046908@uacam.mx",
  "lth74@umsystem.edu",
  "a13114865@alumnos.uady.mx",
  "kvnfh@mst.edu",
  "er.sallasanjay@gmail.com",
  "maya.hajj.obeid@u-picardie.fr",
  "kva180032@siswa.um.edu.my",
  "201961103079@njtech.edu.cn",
  "tb6292@bennett.edu.in",
  "adriagnicbc@gmail.com",
  "mkarthi26@gmail.com",
  "chandujntum@gmail.com",
  "antonio_troni@hotmail.com",
  "bonifacio.manriquemr@uanl.edu.mx",
  "timam20@bath.ac.uk",
  "ana.munozenz@uanl.edu.mx",
  "wjw@seu.edu.cn",
  "ce16resch11005@iith.ac.in"
];

export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false
    };
  },
  methods: {
    Login() {
      this.loading = true;
      let pwd = this.password;
      if (posterAuthorsEmails.includes(this.email)) {
        pwd = `rilemweek${this.password}`;
      }
      auth.signInWithEmailAndPassword(this.email, pwd).catch(error => {
        this.loading = false;
        if (error.code == "auth/user-not-found") {
          swal("Error", "Usuario no encontrado", "error");
        } else if (error.code == "auth/wrong-password") {
          swal("Error", "Contraseña Incorrecta", "error");
        } else {
          swal("Error", error.message, "error");
        }
      });
    },
    Ruta(name) {
      this.$router.push({ name: name });
    },
    Nada() {}
  },
  computed: {},
  mounted() {},
  created() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Login.vue